import { MenuItem } from '@fountain/fountain-ui-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';

import globalMessages from 'shared/global/messages';

import useNavItemStyles from '../NavigationMenuItem/styles';
import NavLink from '../NavLink';
import messages from './messages';

export default function AnalyticsBetaNavLink({
  permission,
  menuItem,
  lookerAnalyticsEnabled,
}) {
  const navClasses = useNavItemStyles();
  const { accountSlug } = useParams();
  const analyticsUrl = `/${accountSlug}/analytics_dashboard_beta`;

  const regEx = new RegExp(`/([^/]*)/analytics_dashboard_beta`);
  const active = regEx.test(window.location.pathname);

  const menuItemProps = {
    classes: { root: navClasses.root, selected: navClasses.selected },
    selected: active,
    disabled: active,
    href: analyticsUrl,
    isExternalLink: true,
    className: navClasses.menuListItem,
  };

  const messagesLabel = lookerAnalyticsEnabled
    ? messages.analyticsBeta
    : globalMessages.analytics;

  return (
    <>
      {menuItem ? (
        <MenuItem {...menuItemProps}>
          <FormattedMessage {...messagesLabel} />
        </MenuItem>
      ) : (
        <NavLink
          active={active}
          display={permission}
          link={analyticsUrl}
          message={messagesLabel}
          dataTestid="analytics_dashboard_beta"
        />
      )}
    </>
  );
}

AnalyticsBetaNavLink.propTypes = {
  permission: PropTypes.bool.isRequired,
  menuItem: PropTypes.bool,
  lookerAnalyticsEnabled: PropTypes.bool.isRequired,
};
